<div [formGroup]="addressesForm" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
    <div class="form-title-container">
        <h3>Domicilios</h3>
        <a class="button add-button" (click)="openAddressModal()">Añadir domicilio</a>
    </div>

    <div class="columns" style="margin-bottom: 1rem;">
        <div class="column is-4">
            <span class="label">Filtrar por tipo de domicilio</span>
            <p-dropdown 
                [options]="clientConstants.DOMICILES" 
                optionLabel="label" 
                optionValue="value" 
                placeholder="Todos los domicilios" 
                [(ngModel)]="selectedTypeFilter"
                (onChange)="onTypeFilterChange()"
                [showClear]="true"
                [emptyFilterMessage]="'No se encontraron resultados'"
                [ngModelOptions]="{standalone: true}"
                [variant]="selectedTypeFilter ? 'filled' : 'outlined'">
            </p-dropdown>
        </div>
    </div>

    <div class="card">
        <app-clients-table 
            [configTable]="activeAddressesTableConfig" 
            [snapshotMode]="!!snapshotData"
            (openItemEvent)="openAddressModal($event)" 
            (deleteItemEvent)="openDeleteAddressModal($event)"
            (duplicateItemEvent)="openDuplicateAddressModal($event)">
        </app-clients-table>
    </div>

    <div class="modal" [ngClass]="{'is-active': isAddressModalVisible}">
        <div class="modal-background" (click)="closeAddressModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ editingAddressIndex !== undefined ? 'Editar domicilio' : 'Nuevo domicilio' }}</p>
                <button class="delete" aria-label="close" (click)="closeAddressModal()"></button>
            </header>
            <form [formGroup]="addressForm" (submit)="saveAddress()">
            <section class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-4 form-container">
                            <span class="label">Tipo de domicilio</span>
                            <p-dropdown [options]=" clientConstants.DOMICILES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de domicilio" formControlName="type" [emptyFilterMessage]="'No se encontraron resultados'" [appendTo]="'body'"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Fecha de alta</span>
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"  dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="startDate" [appendTo]="'body'"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Siglas</span>
                            <input class="search-input" type="text" pInputText formControlName="acronym"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Vía pública</span>
                            <input class="search-input" type="text" pInputText formControlName="street"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Número de vía</span>
                            <input class="search-input" type="text" pInputText formControlName="number"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Escalera</span>
                            <input class="search-input" type="text" pInputText formControlName="stairs"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Piso</span>
                            <input class="search-input" type="text" pInputText formControlName="floor"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Puerta</span>
                            <input class="search-input" type="text" pInputText formControlName="door"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Municipio</span>
                            <input class="search-input" type="text" pInputText formControlName="town"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">CP</span>
                            <input class="search-input" type="text" pInputText formControlName="postalCode"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Provincia</span>
                            <p-dropdown 
                                [options]="clientConstants.PROVINCES" 
                                optionLabel="label" 
                                optionValue="value" 
                                placeholder="Seleccionar provincia" 
                                formControlName="province"
                                [filter]="true"
                                [emptyFilterMessage]="'No se encontraron resultados'"
                                [appendTo]="'body'"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">País</span>
                            <p-dropdown 
                                [options]="countryConstants.COUNTRIES_WITH_PHONE" 
                                optionLabel="label" 
                                optionValue="value" 
                                placeholder="Seleccionar país" 
                                formControlName="countrySelector"
                                [filter]="true"
                                [emptyFilterMessage]="'No se encontraron resultados'"
                                [appendTo]="'body'"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Referencia catastral</span>
                            <input class="search-input" type="text" pInputText formControlName="cadastralReference"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Fecha de baja</span>
                            <p-calendar [iconDisplay]="'input'"  dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="endDate" [appendTo]="'body'"/>
                        </div>
                        <div class="column is-12 form-container">
                            <span class="label">Observaciones</span>
                            <textarea class="search-input observations-field" pInputTextarea [autoResize]="true" formControlName="observations" rows="3" maxlength="2000"></textarea>
                        </div>
                    </div>
                </section>
                @if (addressForm.hasError('dateRange')) {
                  <p class="help is-danger" style="padding: 0 24px 12px;">La fecha de fin no puede ser anterior a la de inicio.</p>
                }
                @if (submitError) {
                  <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
                }
                <footer class="modal-card-foot buttons-container">
                    <ng-container *ngIf="snapshotData; else addressEditButtons">
                        <button type="button" class="button cancel-button" (click)="closeAddressModal()">Cerrar</button>
                    </ng-container>
                    <ng-template #addressEditButtons>
                        <button class="button cancel-button" (click)="closeAddressModal()">Cancelar</button>
                        <button class="button save-button" type="submit" [disabled]="!addressForm.valid">Guardar</button>
                    </ng-template>
                </footer>
            </form>
        </div>
    </div>

    <div class="delete-modal" [class.is-active]="isDuplicateAddressModalVisible">
        <div class="delete-modal-background" (click)="closeDuplicateAddressModal()"></div>
            <div class="delete-modal-content">
                <h1 class="delete-modal-title">Duplicar domicilio</h1>
                <div class="delete-modal-body">
                    <div class="column is-12">
                        <span>Selecciona el tipo del domicilio duplicado</span>
                    </div>
                    <div class="column is-12" style="margin-top: 1rem;">
                        <p-dropdown
                            [options]="clientConstants.DOMICILES"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Seleccionar tipo de domicilio"
                            [(ngModel)]="selectedDuplicateType"
                            [ngModelOptions]="{standalone: true}"
                            [showClear]="true"
                            [emptyFilterMessage]="'No se encontraron resultados'"
                        ></p-dropdown>
                    </div>
                    <div class="delete-modal-buttons" style="margin-top: 1rem;">
                        <button class="button is-outlined cancel-button" (click)="closeDuplicateAddressModal()">Cancelar</button>
                        <button class="comment-button button is-pulled-right" (click)="confirmDuplicateAddress()" [disabled]="!selectedDuplicateType">Aceptar</button>
                    </div>
                </div>             
            </div>
        </div>


    <div class="delete-modal" [class.is-active]="isDeleteAddressModalVisible">
        <div class="delete-modal-background" (click)="closeDeleteAddressModal()"></div>
            <div class="delete-modal-content">
                <h1 class="delete-modal-title">Eliminar domicilio</h1>
                <div class="delete-modal-body">
                    <div class="column is-12">
                        <span>
                            ¿Está seguro/a que desea eliminar el domicilio?
                        </span>
                    </div>
                    @if (submitError) {
                      <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
                    }
                    <div class="delete-modal-buttons">
                        <button class="button is-outlined cancel-button" (click)="closeDeleteAddressModal()">Cancelar</button>
                        <button class="comment-button button is-pulled-right" (click)="confirmDeleteAddress()" >Aceptar</button>      
                    </div>
                </div>             
            </div>
        </div>


   
</div>

<!-- Activities Section -->

